import { render, staticRenderFns } from "./ThirdPartyForm.vue?vue&type=template&id=2adefe6a&"
import script from "./ThirdPartyForm.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports